import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import SectionLoader from '../components/shared/SectionLoader';
import { Button, Divider, TextField, IconButton } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import LanguageIcon from '@material-ui/icons/Language';
import EditIcon from '@material-ui/icons/Edit';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import { toast } from 'react-toastify';
import AppErrorBoundary from '../components/shared/AppErrorBoundary';
import EditCountModal from '../components/modals/EditCountModal';
//API
import AppService from '../services/AppService';

const ApologizePage = () => {
  const [isLoaderOpen, setIsLoaderOpen] = useState(false);
  const [isBtnDisabled, setIsBtnDisabled] = useState(false);
  const [userData, setUserData] = useState('');
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [isRejected, setIsRejected] = useState(false);
  const [isAttended, setIsAttended] = useState(false);
  const [isOnEditMsg, setIsOnEditMsg] = useState(false);
  const [apologizeMessage, setApologizeMessage] = useState('');
  const [disabeApoloizeBtn, setDisabeApoloizeBtn] = useState(false);
  const [occasionType, setOccasionType] = useState(false);
  const [isUpdateCountEnabled, setIsUpdateCountEnabled] = useState(false);
  const [isArabic, setIsArabic] = useState(true); // Will be updated based on userData?.language (0=Arabic, 1=English)
  const params = useParams();
  const [isEditCountModalOpen, setIsEditCountModalOpen] = useState(false);
  const [occasionId, setOccasionId] = useState('');
  const [originalCount, setOriginalCount] = useState('');

  // Text translations object
  const texts = {
    ar: {
      welcome: 'حياكم اللّه',
      totalInvitations: 'اجمالي عدد الدعوات',
      apologized: 'تم الاعتذار عن الحضور',
      attendanceConfirmed: 'تم تأكيد الحضور',
      confirmAttendance: 'تأكيد الحضور',
      apologize: 'الاعتذار',
      attended: 'تم الحضور',
      apologizeReason: 'سبب الاعتذار (ان وجد)',
      congratsMessage: 'ترك رسالة تهنئه',
      send: 'ارسال',
      editAndResend: 'تعديل و اعادة ارسال',
      cancelAttendance: 'تراجع عن الحضور',
      eventLocation: 'اضغط لموقع الحفل',
      copyRights: 'جميع الحقوق محفوظة لشركة دعوة لتنظيم المعارض و المؤتمرات و المعسكرات الرياضية',
      error: 'حدث خطأ',
    },
    en: {
      welcome: 'Welcome',
      totalInvitations: 'Total Invitations',
      apologized: 'Attendance Declined',
      attendanceConfirmed: 'Attendance Confirmed',
      confirmAttendance: 'Confirm Attendance',
      apologize: 'Decline',
      attended: 'Attended',
      apologizeReason: 'Reason for apologize (if any)',
      congratsMessage: 'Leave a congratulatory message',
      send: 'Send',
      editAndResend: 'Edit & Resend',
      cancelAttendance: 'Cancel Attendance',
      eventLocation: 'Click for Event Location',
      copyRights:
        'All rights reserved for Dawa Company for organizing exhibitions, conferences and sports camps',
      error: 'An error occurred',
    },
  };

  const currentTexts = texts[isArabic ? 'ar' : 'en'];

  const fetchUserData = async (userToken) => {
    setIsLoaderOpen(true);
    try {
      const res = await AppService.getUserByToken(userToken);
      setUserData(res?.data);
      setIsConfirmed(res?.data?.isTokenUsed);
      setIsRejected(res?.data?.isRejected);
      setIsAttended(res?.data?.isAttended);
      setApologizeMessage(res?.data?.apologizeMessage);
      setOccasionId(res?.data?.occasionId);
      setIsOnEditMsg(res?.data?.apologizeMessage);
      setOccasionType(res?.data?.type);
      setIsUpdateCountEnabled(res?.data?.allowCountUpdateFromInviteeLink);
      setOriginalCount(res?.data?.originalCount);
      setIsArabic(res?.data?.language === 0 || res?.data?.language === undefined);
      setIsLoaderOpen(false);
    } catch (err) {
      setIsLoaderOpen(false);
    }
  };

  const isSecretOccasion = params?.id === '01JRH16HST4DQNS3FT8H3WR6PZ';

  useEffect(() => {
    fetchUserData(params?.id);
  }, []);

  const handleConfirm = async (isConfirmed) => {
    const dataBody = {
      accept: isConfirmed,
    };
    setIsBtnDisabled(true);
    try {
      await AppService.getConfirmAttend(dataBody, userData?.id);
      setTimeout(() => {
        fetchUserData(params?.id);
      }, 200);
      setIsBtnDisabled(false);
    } catch (err) {
      toast.error(err?.response?.data?.message ?? currentTexts.error);
      setIsBtnDisabled(false);
    }
  };

  const handleApologizeMessage = async () => {
    const dataBody = {
      apologizeMessage,
    };
    setDisabeApoloizeBtn(true);
    try {
      await AppService.getApologizeMessage(dataBody, userData?.id);
      setTimeout(() => {
        fetchUserData(params?.id);
      }, 200);
      setDisabeApoloizeBtn(false);
    } catch (err) {
      toast.error(err?.response?.data?.message ?? currentTexts.error);
      setDisabeApoloizeBtn(false);
    }
  };

  return (
    <AppErrorBoundary>
      <div className="apologize-container" dir={isArabic ? 'rtl' : 'ltr'}>
        {/* Language Toggle Button */}
        <div
          style={{
            position: 'absolute',
            top: 20,
            right: 20,
            zIndex: 1000,
          }}
        >
          <Button
            onClick={() => setIsArabic(!isArabic)}
            style={{
              backgroundColor: '#006782',
              color: 'white',
              minWidth: '80px',
              fontSize: '12px',
              textTransform: 'none',
              borderRadius: '20px',
              padding: '8px 16px',
            }}
            startIcon={<LanguageIcon style={{ marginLeft: 8 }} />}
          >
            {isArabic ? 'English' : 'العربية'}
          </Button>
        </div>

        {isLoaderOpen ? (
          <SectionLoader />
        ) : (
          <>
            <div>
              <div className="apologize-wrapper">
                <h3 className="welcome-msg">{currentTexts.welcome}</h3>
                <p className="invitee-name">{userData?.name}</p>
                {!isSecretOccasion && (
                  <div className="invitees-count">
                    <div>{currentTexts.totalInvitations}</div>
                    <Divider orientation="vertical" style={{ backgroundColor: 'white' }} />
                    <span>{userData?.qrCodes?.length}</span>
                  </div>
                )}
                {isUpdateCountEnabled && !isAttended && (
                  <IconButton
                    style={{
                      padding: '5px 5px 5px 0px',
                      color: 'white',
                      fontSize: '12px',
                      backgroundColor: '#006782',
                      borderRadius: '5px',
                    }}
                    className="menu-icon"
                    onClick={() => setIsEditCountModalOpen(true)}
                  >
                    تعديل عدد الدعوات
                    <EditIcon style={{ marginRight: '5px', marginLeft: '5px', fontSize: '18px' }} />
                  </IconButton>
                )}
                {occasionType !== 2 && (
                  <>
                    {isConfirmed ? (
                      userData?.isRejected ? (
                        <div className="apologize-header">{currentTexts.apologized}</div>
                      ) : (
                        <div
                          style={{
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            display: isSecretOccasion ? 'none' : 'flex',
                          }}
                        >
                          <Button
                            style={{
                              backgroundColor: '#249504',
                              color: 'white',
                              margin: '20px 0px',
                            }}
                            variant="contained"
                          >
                            {currentTexts.attendanceConfirmed}
                          </Button>

                          <img
                            style={{ width: 70, borderRadius: 20 }}
                            src="https://imagecdn.prod.floward.com/web/files/tickets/826a812b-2cd4-4cf0-b2fa-87b019f05c8b.jpg"
                          />
                        </div>
                      )
                    ) : (
                      <>
                        {!isAttended ? (
                          <AppErrorBoundary>
                            {userData && (
                              <div>
                                <Button
                                  style={{ backgroundColor: '#249504', color: 'white', margin: 5 }}
                                  variant="contained"
                                  onClick={() => handleConfirm(true)}
                                  endIcon={
                                    <CheckCircleIcon
                                      style={{
                                        marginRight: isArabic ? 7 : 0,
                                        marginLeft: isArabic ? 0 : 7,
                                        marginTop: 3,
                                      }}
                                    />
                                  }
                                  disabled={isBtnDisabled}
                                >
                                  {currentTexts.confirmAttendance}
                                </Button>
                                <Button
                                  style={{ margin: 5, backgroundColor: '#A91B0D', color: 'white' }}
                                  variant="contained"
                                  onClick={() => handleConfirm(false)}
                                  disabled={isBtnDisabled}
                                >
                                  {currentTexts.apologize}
                                </Button>
                              </div>
                            )}
                          </AppErrorBoundary>
                        ) : (
                          <div className="confirm-header">{currentTexts.attended}</div>
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
              {(isRejected || isConfirmed) && (
                <div
                  className="input-wrapper"
                  style={{
                    marginTop: 20,
                    flexDirection: 'Column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: isSecretOccasion ? 'none' : 'flex',
                  }}
                >
                  <label className="input-label" htmlFor="driver-sdate">
                    {isRejected ? currentTexts.apologizeReason : currentTexts.congratsMessage}
                  </label>
                  {apologizeMessage && isOnEditMsg ? (
                    <div>
                      <p className="welcome-msg" style={{ padding: 5 }}>
                        "{apologizeMessage}"
                      </p>
                    </div>
                  ) : (
                    <TextField
                      style={{ marginTop: 10, width: '75%' }}
                      id="driver-sdate"
                      variant="outlined"
                      type="text"
                      multiline
                      value={apologizeMessage}
                      onChange={(e) => setApologizeMessage(e.target.value)}
                    />
                  )}
                  {!isOnEditMsg && (
                    <Button
                      style={{ backgroundColor: '#006782', color: 'white', margin: 5 }}
                      variant="contained"
                      onClick={handleApologizeMessage}
                      disabled={disabeApoloizeBtn}
                    >
                      {currentTexts.send}
                    </Button>
                  )}
                  {apologizeMessage && isOnEditMsg && (
                    <Button
                      style={{ backgroundColor: '#006782', color: 'white', margin: 5 }}
                      variant="contained"
                      onClick={() => setIsOnEditMsg(false)}
                    >
                      {currentTexts.editAndResend}
                    </Button>
                  )}
                  {isConfirmed && !isRejected && (
                    <Button
                      variant="contained"
                      type="submit"
                      onClick={() => setIsConfirmed(false)}
                      color="default"
                      className="return-btn"
                      size="small"
                    >
                      {currentTexts.cancelAttendance}
                    </Button>
                  )}
                </div>
              )}

              {userData?.addressName &&
                userData?.latitude !== 0 &&
                userData?.longitude !== 0 &&
                !isRejected &&
                isConfirmed && (
                  <div className="location-btn-wrapper">
                    <a
                      className="location-btn"
                      href={`https://www.google.com/maps/?q=${userData?.latitude},${userData?.longitude}`}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '5px',
                      }}
                    >
                      <LocationOnIcon style={{ fontSize: '20px' }} />
                      {currentTexts.eventLocation}
                    </a>
                  </div>
                )}
            </div>
            <div style={{ textAlign: 'center' }}>
              <img
                className="header-ops-img"
                src={
                  'https://imagecdn.prod.floward.com/web/files/tickets/131ba08f-54fd-4d95-b6c4-dd13354d646e.png'
                }
                style={{ width: 110, borderRadius: 5, paddinTop: 30 }}
              />
            </div>
          </>
        )}
        <AppErrorBoundary>
          <p className="copy-rights">
            {currentTexts.copyRights} © {new Date()?.getFullYear()}
          </p>
        </AppErrorBoundary>
      </div>
      <EditCountModal
        selectedInv={userData}
        isPopupOpen={isEditCountModalOpen}
        setIsPopUpOpen={setIsEditCountModalOpen}
        occasionId={occasionId}
        fetchUserData={fetchUserData}
        userToken={params?.id}
        originalCount={originalCount}
      />
    </AppErrorBoundary>
  );
};

export default ApologizePage;
